import type { Element } from '@/components/canvas/document/publicTypes';
import type { Block } from '@/components/canvas/blocks/types';

export function blockToSelectionElement(
  block: Block,
  dragOffset: { dx: number; dy: number },
  resizePreview: { x: number; y: number; width: number; height: number } | null,
  resizeBlockId: string | null,
): Element {
  const usePreview = resizeBlockId === block.id && resizePreview;
  const x = (usePreview ? resizePreview.x : block.layout.x) + dragOffset.dx;
  const y = (usePreview ? resizePreview.y : block.layout.y) + dragOffset.dy;
  const width = usePreview ? resizePreview.width : block.layout.width;
  const height = usePreview ? resizePreview.height : block.layout.height;

  return {
    id: block.id,
    type: 'rect',
    name: block.name ?? '',
    layout: { x, y, zIndex: block.layout.zIndex, rotation: block.layout.rotation ?? 0 },
    size: { width, height },
    appearance: {},
    interaction: { visible: true, locked: false, selectable: true, resizable: true, draggable: true },
    meta: {},
    data: {},
  } as unknown as Element;
}
